import axios from "axios";
import {getMsalIdToken} from './helpers';
import { store } from "../store/store";

const instance = axios.create();
instance.defaults.headers.common["Accept"] = "application/json";
instance.defaults.headers.common["Content-Type"] = "application/json";
instance.defaults.withCredentials = true;

instance.interceptors.response.use(
  async function (response) {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;
    if (error.response?.status === 401 || error.response.status === 401 || error.status === 401 || error.message === 'Request failed with status code 401') {
        const idToken = await getMsalIdToken();
        store.commit('setShouldShowUnauth', true);
        axios.defaults.headers.common["Authorization"] = `Bearer ${idToken}`;
        instance.defaults.headers.common["Authorization"] = `Bearer ${idToken}`;
        originalRequest.headers.Authorization = `Bearer ${idToken}`;
        return instance(originalRequest);
    }
    return Promise.reject(error);
  }
);

export default instance;
